<template>
  <div>
    <div>
      <div id="cotisationTable" style="margin-top: 10px">
        <div style="font-weight: bold" class="td td_soin pTop16">
          <span>Soin</span>&nbsp;
        </div>
        <div style="font-weight: bold" class="td td_pre_hol pTop16">
          <span>Frais réels</span>&nbsp;
        </div>
        <div style="font-weight: bold" class="td td_pre_hol pTop8">
          <span>Remboursement<br />RO</span>&nbsp;
        </div>
        <div style="font-weight: bold" class="td td_pre_hol pTop8">
          <span>Remboursement<br />autre mutuelle</span>&nbsp;
        </div>
        <div class="td split"></div>
        <div class="td td_pre_hol pTop8">
          <span>Remboursement<br />CPMS Base</span>&nbsp;
        </div>
        <div class="td td_pre_hol pTop8">
          <span>Remboursement<br />CPMS Option</span>&nbsp;
        </div>
        <div class="td td_pre_hol pTop8">
          <span>Remboursement<br />CPMS sur c.</span>&nbsp;
        </div>
        <div class="td td_pre_hol pTop8" style="font-weight: bold">
          <span>Remboursement<br />CPMS TOTAL</span>&nbsp;
        </div>
      </div>

      <a-divider></a-divider>

      <div v-for="(s, k) in sTLy" :class="'tr ' + k" :key="k">
        <div class="td td_soin" style="font-weight: bold">{{ getSoin(k) }}</div>

        <div class="td td_pre_hol">
          <div style="color: green">
            <span v-money-format="s.FR[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="s.FR[1]"></span> €
          </div>
        </div>

        <div class="td td_pre_hol">
          <div style="color: green">
            <span v-money-format="s.SS[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="s.SS[1]"></span> €
          </div>
        </div>

        <div class="td td_pre_hol">
          <div style="color: green">
            <span v-money-format="s.AU[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="s.AU[1]"></span> €
          </div>
        </div>

        <div class="td td_pre_hol">
          <div style="color: green">
            <span v-money-format="s.B[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="s.B[1]"></span> €
          </div>
        </div>

        <div class="td td_pre_hol">
          <div style="color: green">
            <span v-money-format="s.O[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="s.O[1]"></span> €
          </div>
        </div>

        <div class="td td_pre_hol">
          <div style="color: green">
            <span v-money-format="s.S[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="s.S[1]"></span> €
          </div>
        </div>

        <div class="td td_pre_hol" style="font-weight: bold">
          <div style="color: green">
            <span v-money-format="s.T[0]"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="s.T[1]"></span> €
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "Soin",
    width: 220,
    dataIndex: "soin",
    key: "soin",
    slots: {
      customRender: "soin",
    },
  },
  {
    title: "Frais réels",
    width: 220,
    sorter: false,
    dataIndex: "frais_reels",
    key: "frais_reels",
    slots: {
      customRender: "frais_reels",
    },
  },
  {
    title: "Remboursement RO ",
    width: 100,
    dataIndex: "remboursement_ro",
    key: "remboursement_ro",
    slots: {
      customRender: "remboursement_ro",
    },
  },
  {
    title: "Remboursement autre mutuelle",
    width: 100,
    dataIndex: "remboursement_autre_mutuelle",
    key: "remboursement_autre_mutuelle",
    slots: {
      customRender: "remboursement_autre_mutuelle",
    },
  },
  {
    title: "Remboursement CPMS Base",
    width: 100,
    dataIndex: "remboursement_cpms_base",
    key: "remboursement_cpms_base",
    slots: {
      customRender: "remboursement_cpms_base",
    },
  },
  {
    title: "Remboursement CPMS Option",
    width: 100,
    dataIndex: "remboursement_cpms_option",
    key: "remboursement_cpms_option",
    slots: {
      customRender: "remboursement_cpms_option",
    },
  },
  {
    title: "Remboursement CPMS sur c.",
    width: 100,
    dataIndex: "remboursement_cpms_surc",
    key: "remboursement_cpms_surc",
    slots: {
      customRender: "remboursement_cpms_surc",
    },
  },
  {
    title: "Remboursement CPMS total",
    width: 100,
    dataIndex: "remboursement_cpms_total",
    key: "remboursement_cpms_total",
    slots: {
      customRender: "remboursement_cpms_total",
    },
  },
];

export default {
  name: "PrestationEntrepriseTable",
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sTLy: {},
      columns,

      sort: {
        columnKey: null,
        order: null,
      },

      prestationsData: {
        data: [],
      },

      loading: false,

      timeout: 0,
    };
  },
  watch: {
    spaEr(_) {
      // Reset Pagination
      this.params.page = 1;
      this.getPrestations();
    },
    _searchValue(_) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.params.page = 1;
        this.getPrestations();
      }, 500);
    },
  },
  methods: {
    getPrestations() {
      this.loading = true;

      let url = `data/prestations/${this.numHolding}/${
        this.numEntreprise
      }/?${new URLSearchParams(this.params)}`;

      this.axios.get(url).then((r) => {
        if (r.status === 200) {
          this.prestationsData = r.data;

          var soins = {
              FR: {},
              CV: {},
              HO: {},
              OP: {},
              PH: {},
              SC: {},
              AD: {},
              AU: {},
              TT: {},
            },
            tly = {};

          Object.keys(soins).forEach(
            (snKey) =>
              (tly[snKey] = {
                B: [0, 0],
                O: [0, 0],
                S: [0, 0],
                FR: [0, 0],
                SS: [0, 0],
                AU: [0, 0],
                T: [0, 0],
              })
          );

          r.data.data.filter(p => {
            Object.keys(p.ty).forEach((keyP) => {
              Object.keys(p.ty[keyP]).forEach((keyS) => {
                tly[keyP][keyS][0] += p.ty[keyP][keyS];
                tly["TT"][keyS][0] += p.ty[keyP][keyS];
              });
            });
            Object.keys(p.ly).forEach((keyP) => {
              Object.keys(p.ly[keyP]).forEach((keyS) => {
                tly[keyP][keyS][1] += p.ly[keyP][keyS];
                tly["TT"][keyS][1] += p.ly[keyP][keyS];
              });
            });
          });

          Object.keys(tly).forEach((sk) => {
            Object.keys(tly[sk]).forEach((vk) => {
              if (vk == "B" || vk == "O" || vk == "S") {
                tly[sk]["T"][0] += parseFloat(tly[sk][vk][0]);
                tly[sk]["T"][1] += parseFloat(tly[sk][vk][1]);
              }
            });
          });

          this.sTLy = tly;

          setTimeout(() => {
            this.loading = false;
          }, 100);
        }
      });
    },
    getSoin(soin) {
      if (soin == "FR") return "Forfaits";
      if (soin == "CV") return "Consultat./Visites";
      if (soin == "HO") return "Hospitalisation";
      if (soin == "OP") return "Optique";
      if (soin == "PH") return "Pharmacie";
      if (soin == "SC") return "Soins courants";
      if (soin == "AD") return "Art Dentaire";
      if (soin == "TT") return "Totaux";
      return "Autre";
    },
    handleTableChange(pag, _, sorter) {
      this.loading = true;
      this.sort.columnKey = sorter.columnKey;
      this.sort.order = sorter.order;

      this.params.page = pag.current;

      this.getPrestations();
    },
  },
  computed: {
    _searchValue() {
      return this.params.searchValue;
    },
    spaEr() {
      return this.params.spaEr.spa + this.params.spaEr.er.status;
    },
    numHolding() {
      return this.$route.params.numHolding;
    },
    numEntreprise() {
      return this.$route.params.numEntreprise;
    },
    headers() {
      return this.$store.getters.headers.hhp;
    },
    ac() {
      return this.$store.getters.activeColumns.h;
    },
    noZeroData() {
      return this.$store.getters.noZeroData.h;
    },
    pagination() {
      return {
        total: this.prestationsData.total,
        current: this.prestationsData.current_page,
        columnKey: this.params.columnKey,
        order: this.params.order,
      };
    },
    translate() {
      return this.$store.getters.translate;
    },
    cotisations() {
      return this.prestationsData.data.filter((c) => {
        return c;
      });
    },
  },
  mounted() {
    this.getPrestations();
  },
};
</script>

<style>
.td_soin {
  width: 120px;
  float: left;
  text-align: left;
  line-height: inherit;
  padding-top: 7px;
}
</style>
